import { companyIndustry } from "../pages/CompanyInfoPage/data/companyIndustry";

// The list of countries for the US entity is also defined in the LS DB view [sync].[vw_SupplierEntityCountries]
// If you want to change the list, you probably want to change the SQL view as well.
export const countriesDirectedToErnestCalendly = ["AS", "AU", "CA", "GU", "MI", "MP", "NZ", "PR", "RE", "UM", "US", "VI", "WK"];

export const getIndustryGuidsForNewDesignPage = () => {
    const targetIndustries = [
        'Consulting',
        'Construction/Home Service',
        'IT/Technology',
        'Insurance Broker',
        'Finance',
        'Manufacturing'
    ];

    return companyIndustry
        .filter(industry => targetIndustries.includes(industry.en))
        .map(industry => industry.itemGuid);
};

export const calendlyUrlParams = "hide_gdpr_banner=1";

export const calendlyUrls = {
    cs: `https://calendly.com/jiri-tvorik-eway-crm/onboarding-czech?${calendlyUrlParams}`,
    enJiri: `https://calendly.com/jiri-tvorik-eway-crm/onboarding?${calendlyUrlParams}`,
    enErnest: `https://calendly.com/ernest-cory-eway-crm/onboarding?${calendlyUrlParams}`,
};